module.exports = __webpack_public_path__ + "img/main_6.5d5975f5.jpg";